/* eslint-disable */
import * as util from "@/api/instagramAccountOfficial";

const state = {
    profileAccount: []
};

const mutations = {
    SET_profileAccount: (state, value) => {
        state.profileAccount = value.data[0]
    },
};

const actions = {
    updateUserStats({ commit }, instagramId) {
        return new Promise((resolve, reject) => {
            util.updateUserStats(instagramId).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    connectAccountsFullAccess({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.connectAccountsFullAccess(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    refreshToken({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.refreshToken(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getInstagramBusinessAccount({ commit }, dataParam) {
        return new Promise((resolve, reject) => {
            util.getInstagramBusinessAccount(dataParam).then(response => {
                resolve(response);
            }).catch(error => {
                reject(error);
            });
        });
    },
    getProfile({commit}, instagram_id) {
        return new Promise((resolve, reject) => {
            util.getProfile(instagram_id)
                .then(response => {
                    commit('SET_profileAccount', response)
                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
    getInsightProfile({commit}, instagram_id) {
        return new Promise((resolve, reject) => {
            util.getInsightProfile(instagram_id)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    },
    getInsightProfilePercent({commit}, dataParam) {
        return new Promise((resolve, reject) => {
            util.getInsightProfilePercent(dataParam)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    },
    getInsightPost({commit}, instagram_id) {
        return new Promise((resolve, reject) => {
            util.getInsightPost(instagram_id)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    },
    getInsightPostPercent({commit}, dataParam) {
        return new Promise((resolve, reject) => {
            util.getInsightPostPercent(dataParam)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    },
    getMedia({commit}, data) {
        return new Promise((resolve, reject) => {
            util.getMedia(data)
                .then(response => resolve(response))
                .catch(error => reject(error))
        })
    }
};


export default {
    namespaced: true,
    state,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/instagramAccountOfficial.js